import { ACTION_TYPES } from "../actions/types";

const initialState = {
  iamRoles: [],
  permissions: [],
  permissionsLoading: false,
};

export default function reducerCase(state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPES.GET_IAM_ROLES:
      return {
        ...state,
        iamRoles: action.payload,
      };

    case ACTION_TYPES.SET_PERMISSIONS_LOADING:
      return {
        ...state,
        permissionsLoading: action.payload,
      };
    default:
      return state;
  }
}
